import { create } from "zustand";
import { Location } from "@/types";
// this store is used to track the seletcedLocation in the origin view

interface OriginStore {
  selectedLocation: Location | null;
  setSelectedLocation: (location: Location) => void;
}

const useOriginStore = create<OriginStore>((set) => ({
  selectedLocation: null,
  setSelectedLocation: (location) => set({ selectedLocation: location }),
}));

export default useOriginStore;
